import styled from "styled-components";
import PointerC from "assets/images/Pointer.svg";
const formBreakpoint = '999.9px'

export const ListContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 20.8rem;
  max-height: 23rem;
  padding: 1.6rem;

  background-color: var(--light);
  border-radius: 8px;
  box-shadow: 0 6px 6px var(--shadow), inset 0 0 0 1px var(--shadow);
  overflow-y: auto;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (max-width:${formBreakpoint}) {
    width: 100%;
  }
`;

export const DropDownContainer = styled(ListContainer)`
  width: 42rem;

  @media (max-width:${formBreakpoint}) {
    width: 100%;
  }
`

export const List = styled.ul`
  position: relative;
  list-style: none;

  & > *:not(:last-child) {
    margin-bottom: .8rem;
  }
`;

export const ListSubHeader = styled.p`
  position: relative;
  margin-bottom: 0.8rem;
  font-size: 1.2rem;
  line-height: 2rem;
  color: var(--text-light);

  @media (max-width:${formBreakpoint}) {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.4rem;
  }
`;

type ListItemProps = {
  selected?: boolean;
  isSubItem?: boolean;
}
export const ListItem = styled.li<ListItemProps>`
  position: relative;
  width: 100%;
  padding: 0.8rem;

  display: flex;
  align-items: center;
  border-radius: 6px;
  white-space: nowrap;
  background-color: ${(props) => (props.selected ? "var(--grey-100)" : "none")};
  padding-left: ${(props) => props.isSubItem ? '3.2rem' : '0.8rem'};
  cursor: url(${PointerC}), auto;

  & > p {
    color: var(--text-medium);
    font-weight: 500;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  & .highlighted-airport * {
    fill: var(--brand-700);
  }
`;

export const ListIcon = styled.span`
  display: inline-block;
  width: 2rem;
  height: 2rem;
  text-align: center;
  margin-right: 1.6rem;
`

export const BaseListItem = styled(ListItem)`
  &:hover {
    background: var(--grey-100);
  }
`

export const Decoration = styled.div`
  height: 0.01em;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: var(--text-light);
  margin-right: 1.6rem;
`;
